import React from 'react';

import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';

export const DeclarationOfLoss = lazy(
  () =>
    import('./DeclarationOfLoss.eager').then(mod => ({
      default: mod.DeclarationOfLossEager,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
    isSsrAndNeedsHydration: true,
  },
);
